import { JwtPayload, jwtDecode } from 'jwt-decode';

export function getCompanyInfoId(token: string): string {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded['company_info'].id.toString();
  } catch {
    return '';
  }
}
